/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="7">
        <div class="leftaside">
          <h4>商家入驻指南</h4>
          <div class="left_product">
            <el-menu
              default-active="3"
              class="el-menu-vertical-demo"
              :unique-opened="true"
              background-color="#f7f8f8"
            >
              <el-submenu index="1">
                <template slot="title">入驻流程</template>
                <el-menu-item index="0-1">商家提交申请</el-menu-item>
                <el-menu-item index="0-2">平台审核资质</el-menu-item>
                <el-menu-item index="0-3">商家缴纳费用</el-menu-item>
                <el-menu-item index="0-4">店铺开通</el-menu-item>
              </el-submenu>
              <el-menu-item index="2">
                <template slot="title"
                  >签订入驻协议</template
                >
              </el-menu-item>
              <el-menu-item index="3">
                <template slot="title"
                  >选择店铺类型</template
                >
              </el-menu-item>
              <el-menu-item index="4">
                <template slot="title"
                  >平台审核</template
                >
              </el-menu-item>
              <el-menu-item index="5">
                <template slot="title"
                  >合同签订及缴费</template
                >
              </el-menu-item>
              <el-menu-item index="6">
                <template slot="title"
                  >店铺开通</template
                >
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="leftaside">
          <h4>平台联系方式</h4>
          <div class="left_product" style="padding: 20px">
            <p>电话：400-0404-119</p>
            <p>邮箱：nays@nays.com.cn</p>
          </div>
        </div>
      </el-col>
      <el-col :span="17" class="rightaside">
        <div>
          <h3><strong>提示</strong>: 信息提交过后不可进行修改，请慎重填写！</h3>
          <el-divider></el-divider>
          <p>公司信息:</p>
          <el-form
            :rules="rules"
            ref="sizeForm"
            label-width="150px"
            :model="sizeForm"
            size="mini"
            class="nextPart"
          >
            <el-form-item label="企业全称" prop="companyName">
              <el-input  v-model="sizeForm.companyName" placeholder="企业全称"></el-input>
            </el-form-item>
            <el-form-item label="公司所在地" prop="companyLocation">
                <el-cascader
                  placeholder="公司所在地"
                  :props="{ checkStrictly: true }"
                  ref="area"
                  :options="getprovince"
                  @change="areaHandleChange">
                </el-cascader>              
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input  v-model="sizeForm.address" placeholder="请输入公司详细地址" minlength='6'></el-input>
            </el-form-item>
            <el-form-item label="邮编" prop="postalCode">
              <el-input  v-model="sizeForm.postalCode" placeholder="请输入公司邮编"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input    v-model="sizeForm.phone" placeholder="请输入公司电话"></el-input>
            </el-form-item>
            <el-form-item label="公司网址" prop="companyUrl">
              <el-input  v-model="sizeForm.companyUrl" placeholder="请输入公司网址"></el-input>
            </el-form-item>
            <el-form-item label="公司介绍" prop="companyProfile">
              <el-input  v-model="sizeForm.companyProfile" placeholder="请输入公司介绍"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contactPerson">
              <el-input  v-model="sizeForm.contactPerson" placeholder="联系人"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input  v-model="sizeForm.position" placeholder="职位"></el-input>
            </el-form-item>
            <el-form-item  label="联系人电话" prop="emergencyManCall">
              <el-input  v-model.number="sizeForm.emergencyManCall" placeholder="联系人电话"></el-input>
            </el-form-item>
            <el-form-item label="联系人邮箱" prop="emergencyManEmail">
              <el-input  v-model="sizeForm.emergencyManEmail" placeholder="联系人邮箱"></el-input>
            </el-form-item>
            <el-form-item label="注册资金" prop="registeredCapital">
              <el-input  v-model="sizeForm.registeredCapital" placeholder="注册资金"></el-input>
            </el-form-item>
            <el-form-item label="员工总数" prop="staffNum">
              <el-input  v-model.number="sizeForm.staffNum" placeholder="员工总数"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" prop="taxpayerNumber">
              <el-input  v-model="sizeForm.taxpayerNumber" placeholder="纳税人识别号"></el-input>
            </el-form-item>
            <el-form-item label="发票抬头" prop="invoice">
              <el-input  v-model="sizeForm.invoice" placeholder="发票抬头"></el-input>
            </el-form-item>
            <el-form-item label="是否申请快捷通" v-if="kjtEnableObj.enable">
               <el-switch class="kjt" v-model="kjtSwitch" @change='getkjtSwitch' inactive-color="#cacaca" active-color="#13ce66"></el-switch>
            </el-form-item>
            <!-- 快捷通资料 -->
            <div class="invoiceBox" v-if="kjtSwitch">
                <el-form-item label="商户类型">
                  <el-radio  v-model="sizeForm.kjtMerchant.customerType" label="1" @change="changeCheckRadio()" >企业 </el-radio>
                </el-form-item>
                    <el-form-item label="姓名" prop="kjtMerchant.name" >
                  <el-input  v-model="sizeForm.kjtMerchant.name" placeholder="请输入商家姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="kjtMerchant.certificatesNumber">
                  <el-input  v-model="sizeForm.kjtMerchant.certificatesNumber" placeholder="请输入证件号码"></el-input>
                </el-form-item>
                <el-form-item label="身份有效期" prop="kjtMerchant.certificatesValidity">
                  <el-input  v-model="sizeForm.kjtMerchant.certificatesValidity" placeholder="请输入身份有效期 格式:YYYY-mm-dd"></el-input>
                </el-form-item>
                <el-form-item label="银行卡类别">
                  <el-radio
                    v-model="sizeForm.kjtMerchant.radio"
                    label="1"
                    @change="changekjtMerchantRadio()"
                  >
                  对公
                  </el-radio>
                  <!-- <el-radio
                    v-model="sizeForm.kjtMerchant.radio"
                    label="2"
                    @change="changekjtMerchantRadio()"
                  >
                  对私
                  </el-radio> -->
                </el-form-item>
                <el-form-item label="结算银行卡号" prop="kjtMerchant.bankCardNo">
                  <el-input  v-model="sizeForm.kjtMerchant.bankCardNo" placeholder="只支持借记卡"></el-input>
                </el-form-item>
                <el-form-item label="银行卡户名" prop="kjtMerchant.bankAccountName">
                  <el-input  v-model="sizeForm.kjtMerchant.bankAccountName" placeholder="请输入银行卡户名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="开户银行编码" prop="kjtMerchant.bankCode">
                  <el-input  v-model="sizeForm.kjtMerchant.bankCode" placeholder="请输入开户银行编码" 
                  ></el-input>
                </el-form-item>
                <el-form-item label="开户行名称" prop="kjtMerchant.bankName">
                  <el-input  v-model="sizeForm.kjtMerchant.bankName" placeholder="请输入开户行名称"  minlength="2" maxlength="16"></el-input>
                </el-form-item>
                <el-form-item label="开户行所在地" prop="bankLocation">
                    <el-cascader
                      placeholder="开户行所在地"
                      v-model="bankLocation"
                      :props="{ checkStrictly: true }"
                      :options="getprovince"
                      @change="bankAreaHandleChange">
                    </el-cascader>              
                </el-form-item>
                <el-form-item label="开户银行支行名称" prop="kjtMerchant.bankBranchName">
                  <el-input  v-model="sizeForm.kjtMerchant.bankBranchName" placeholder="请输入开户银行支行名称"></el-input>
                </el-form-item>
                <el-form-item label="营业执照号" prop="kjtMerchant.companyProperty.businessLicenseNo">
                  <el-input  v-model="sizeForm.kjtMerchant.companyProperty.businessLicenseNo" placeholder="请输入证件信息"></el-input>
                </el-form-item>
                <el-form-item label="营业执照有效期" prop="kjtMerchant.companyProperty.businessLicenseValidity">
                  <el-input  v-model="sizeForm.kjtMerchant.companyProperty.businessLicenseValidity" placeholder="营业执照有效期    YYYY-mm-dd格式"></el-input>
                </el-form-item>

                <el-form-item label="营业执照" prop="businessLicense">
                  <el-upload
                        name="file"
                        class="avatar-uploader"
                        :action="`${$baseUrl}/common/service/api/sftp/upload`"
                        :show-file-list="false"
                        accept="image/png,image/jpg"
                        :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,1)"
                        :before-upload="beforeAvatarUpload">
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                        <img v-if="sizeForm.businessLicense" :src="urlImg" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="身份证正面" prop="kjtMerchant.photoCopyMap.certificatesFront">
                  <el-upload
                      name="file"
                      class="avatar-uploader"
                      :action="`${$baseUrl}/common/service/api/sftp/upload`"
                      :show-file-list="false"
                      accept="image/png,image/jpg"
                      :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,2)"
                      :before-upload="beforeAvatarUpload">
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                      <img v-if="sizeForm.kjtMerchant.photoCopyMap.certificatesFront" :src="urlImgTwo" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item> 
                <el-form-item label="身份证反面" prop="kjtMerchant.photoCopyMap.certificatesBack">
                  <el-upload
                      name="file"
                      class="avatar-uploader"
                      :action="`${$baseUrl}/common/service/api/sftp/upload`"
                      :show-file-list="false"
                      accept="image/png,image/jpg"
                      :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,3)"
                      :before-upload="beforeAvatarUpload">
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                      <img v-if="sizeForm.kjtMerchant.photoCopyMap.certificatesBack" :src="urlImgThree" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item> 
                <!-- <el-form-item label="银行卡有卡号的照片" prop="kjtMerchant.photoCopyMap.bankCardFont" v-if="shopType!=1">
                  <el-upload
                      name="file"
                      class="avatar-uploader"
                      :action="`${$baseUrl}/common/service/api/sftp/upload`"
                      :show-file-list="false"
                      accept="image/png,image/jpg"
                      :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,4)"
                      :before-upload="beforeAvatarUpload">
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                      <img v-if="sizeForm.kjtMerchant.photoCopyMap.bankCardFont" :src="urlImgFour" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>  -->
                <!-- <el-form-item label="手持银行卡卡号照片" prop="kjtMerchant.photoCopyMap.bankCardInHand" v-if="shopType!=1">
                  <el-upload
                      name="file"
                      class="avatar-uploader"
                      :action="`${$baseUrl}/common/service/api/sftp/upload`"
                      :show-file-list="false"
                      accept="image/png,image/jpg"
                      :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,5)"
                      :before-upload="beforeAvatarUpload">
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                      <img v-if="sizeForm.kjtMerchant.photoCopyMap.bankCardInHand" :src="urlImgFive" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item> 
                <el-form-item label="手持证件正面的照片" prop="kjtMerchant.photoCopyMap.certificatesInHandFront" v-if="shopType!=1">
                  <el-upload
                      name="file"
                      class="avatar-uploader"
                      :action="`${$baseUrl}/common/service/api/sftp/upload`"
                      :show-file-list="false"
                      accept="image/png,image/jpg"
                      :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,6)"
                      :before-upload="beforeAvatarUpload">
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                      <img v-if="sizeForm.kjtMerchant.photoCopyMap.certificatesInHandFront" :src="urlImgSix" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>  -->
                <el-form-item label="网店的域名截图照片" prop="kjtMerchant.photoCopyMap.networkUrlPhoto" v-if="shopType==1">
                  <el-upload
                      name="file"
                      class="avatar-uploader"
                      :action="`${$baseUrl}/common/service/api/sftp/upload`"
                      :show-file-list="false"
                      accept="image/png,image/jpg"
                      :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,7)"
                      :before-upload="beforeAvatarUpload">
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                      <img v-if="sizeForm.kjtMerchant.photoCopyMap.networkUrlPhoto" :src="urlImgSeven" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item> 
                <el-form-item label="开户许可证影印件" prop="kjtMerchant.photoCopyMap.openLicense" v-if="shopType==1">
                  <el-upload
                      name="file"
                      class="avatar-uploader"
                      :action="`${$baseUrl}/common/service/api/sftp/upload`"
                      :show-file-list="false"
                      accept="image/png,image/jpg"
                      :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,8)"
                      :before-upload="beforeAvatarUpload">
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                      <img v-if="sizeForm.kjtMerchant.photoCopyMap.openLicense" :src="urlImgEight" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item> 

                <el-form-item label="营业执照影印件地址" prop="kjtMerchant.photoCopyMap.license" v-if="shopType!=3">
                  <el-upload
                      name="file"
                      class="avatar-uploader"
                      :action="`${$baseUrl}/common/service/api/sftp/upload`"
                      :show-file-list="false"
                      accept="image/png,image/jpg"
                      :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,9)"
                      :before-upload="beforeAvatarUpload">
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                      <img v-if="sizeForm.kjtMerchant.photoCopyMap.license" :src="urlImgNine" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item> 
            </div>
            <el-form-item label="营业执照" v-if="!kjtSwitch" prop="businessLicense">
              <el-upload
                    name="files"
                    class="avatar-uploader"
                    :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                    :show-file-list="false"
                    
                     :on-success="(response, file, fileList)=> handleAvatarSuccess(response, file, fileList,1)"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="sizeForm.businessLicense" :src="urlImg" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
               </el-upload>
            </el-form-item>
            <p>店铺信息:</p>
            <el-form-item label="店铺名称" prop="name">
              <el-input  v-model="sizeForm.name" placeholder="店铺名称"></el-input>
            </el-form-item>
            <el-form-item label="店铺等级" prop="level">
              <el-select v-model="sizeForm.level" placeholder="请选择店铺等级">
                <el-option  v-for="item in levelList" :key="item.bxslId" :label="`${item.name} 费用:${item.standard} 描述:普通店铺，年费${item.standard}元`" :value="item.bxslId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="店铺分类" prop="sort">
               <el-select v-model="sizeForm.sort" placeholder="请选择店铺分类" @change="getShopid">
                  <el-option
                    v-for="item in storeClasslists"
                    :key="item.bxscId"
                    :label="item.name"
                    :value="item.bxscId"
                    >
                  </el-option>                  
                </el-select>
            </el-form-item>
            <el-form-item label="经营类目" prop="mainproduct">
              <el-cascader
                placeholder="经营类目"
                 ref="cascader"
                :options="leftmenus"
                :props="props"
                @change="getCheckedNodes"
                clearable></el-cascader>
            </el-form-item>
            <!-- <p>用户信息:</p> -->
            <!-- <el-form-item label="登录账号：" prop="sellerAccount">
              <el-input  v-model="sizeForm.sellerAccount" placeholder="登录账号"></el-input>
              <span style="color:#666" class=""><i class="el-icon-info"></i> 默认密码123456</span>
            </el-form-item> -->
            <el-form-item>
              <el-button class="nextButtom" type="primary"  @click="submitApply('sizeForm')">提交申请</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { merchantForm,slevelList, leftmenu,storeClasslist,area_list,kjtEnable } from '@/api/xunyou'
import {mapState,mapMutations} from 'vuex'
export default {
  data() {
    return {
      provincevalue:[],
      props: { multiple: true,checkStrictly: true}, // 联级选择
      urlImg:'', // 用来图片预览的
      bxscId:"",
      kjtSwitch:false,//是否开启快捷通
      sizeForm: {
        type:this.$route.query.type,// 入驻类型 1:商家，2：会员，3：供应商
        businessLicense: '',
        companyName: "",
        companyLocation:'',
        address:'',
        postalCode:'',
        phone:'',
        companyUrl:'',
        companyProfile:'',
        contactPerson:'',
        position:'',
        emergencyManCall:'',
        emergencyManEmail:'',
        registeredCapital:'',
        staffNum:'',
        taxpayerNumber:'',
        invoice:'',
        // businesslicense:'',
        // 店铺信息
        name:'',
        level:'',
        sort:'',
        mainproduct:'',
        sellerAccount: JSON.parse(localStorage.getItem("userdata")).loginName,
         // zt入驻信息
        kjt:0,//是否开启快捷通
        kjtMerchant: {
            name: '',
            email:'',
            province:'',
            city:'',
            area:'',
            address:'',
            shopType:'1',
            customerType:'1',
            certificatesType: '01',
            companyOrPerson:'B',
            certificatesNumber: '',
            certificatesValidity: '',
            bankCardNo:'',
            bankAccountName:'',
            bankCode:'',
            bankName:'',
            bankProv:'',
            bankCity:'',
            bankBranchName:'',
            contact_name:'',
            settleType:'1',
            radio:'1',
            photoCopyMap:{
              certificatesFront:'',
              certificatesFrontBak:'',
              certificatesBack:'',
              certificatesBackBak:'',
              bankCardFont:'',
              bankCardFontBak:'',
              bankCardInHand:'',
              bankCardInHandBak:'',
              certificatesInHandFront:'',
              certificatesInHandFrontBak:'',
              networkUrlPhoto:'',
              networkUrlPhotoBak:'',
              openLicense:'',
              openLicenseBak:'',
              license:'',
              licenseBak:''
            },
            companyProperty:{
              companyName: "",
              threeCertFlag: '1',
              businessLice: '1',
              businessLicenseNo:'',
              businessLicenseValidity:''
            },
            
        },
        // },
        // ruleForm:{
        //   radio:'1'
        // },
      },
      levelList:[], //店铺登记
      storeClasslists:[], //商品分类
      leftmenus:[], // 店铺类目
      showTree:false,
      defaultProps: {
          children: 'subItems',
          label: 'name'
      },
      // 快捷通支付
      kjtEnableObj:{}, // 平台快捷通是否开启
      urlImgTwo:'',
      urlImgThree:'',
      urlImgFour: '',
      urlImgFive:'',
      urlImgSix:'',
      urlImgSeven:'',
      urlImgEight:'',
      urlImgNine:'',
      bankLocation:'',
      shopType:'1',
      userInfo:JSON.parse(localStorage.getItem("userdata")),
      locationId:'',      //地址id

      // getprovince:[],
      rules: {
        companyName: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        companyLocation:[ { required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        address:[{ required: true, trigger: ["blur", "change"],
           validator:(rule, value, callback) => {
             if(value == ''){
               callback(new Error('不能为空,请输入'));
             } else if (value.length<8) {
                          callback(new Error('地址详情至少输入8位'));
                        }else{
                          callback();
                        }
                      }
         },],
        // postalCode:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],//{ type: 'number', message: '必须为数字值'}
        phone:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] }],//{ type: 'number', message: '必须为数字值'}
        // companyUrl:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        // companyProfile:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        contactPerson:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        position:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        emergencyManCall:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },{type:'number',message:'必须填写数字'}],//{ type: 'number', message: '必须为数字值'}
        // emergencyManEmail:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
        registeredCapital:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        staffNum:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },
		{type:'number',message:'必须填写数字'},
		],//{ type: 'number', message: '必须为数字值'}
        taxpayerNumber:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        invoice:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        businessLicense:[{ required: true, message: "不能为空,请上传营业执照", trigger: ["blur", "change"] },],
        // 店铺信息
        name:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        level:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        sort:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        mainproduct:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        // sellerAccount:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        
        // bankLocation:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        'kjtMerchant.name':[{ 
          required: true, 
        
          trigger: "blur",
          validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                        }else{
                          callback();
                        }
                      }
         }],
        'kjtMerchant.certificatesNumber':[
          { required: true,
          
            trigger: "blur",
            validator:(rule, value, callback) => {
                         //验证身份证号码
                            var idcode=value
                            var weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
                            var check_code = ['1', '0', 'X' , '9', '8', '7', '6', '5', '4', '3', '2'];
                            var code = idcode + "";
                            var last = idcode[17];//最后一位
                            var seventeen = code.substring(0,17);
                            var arr = seventeen.split("");
                            var len = arr.length;
                            var num = 0;
                            for(var i = 0; i < len; i++){
                                num = num + arr[i] * weight_factor[i];
                            }
                            var resisue = num%11;
                            var last_no = check_code[resisue];
                            // 正则思路
                            // 第一位不可能是0
                            // 第二位到第六位可以是0-9
                            // 第七位到第十位是年份，所以七八位为19或者20
                            // 十一位和十二位是月份，这两位是01-12之间的数值
                            // 十三位和十四位是日期，是从01-31之间的数值
                            // 十五，十六，十七都是数字0-9
                            // 十八位可能是数字0-9，也可能是X
                            var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
                            var format = idcard_patter.test(idcode);
                            var result=(last === last_no && format)
                         if(!result){
                            callback(new Error('身份证号码不正确'));
                          }else{
                          callback();
                        }
                      }
           },],
        'kjtMerchant.certificatesValidity':[{ required: true,validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      }, trigger: "blur" },],
        'kjtMerchant.radio':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.bankCardNo':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.bankAccountName':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.bankCode':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.bankName':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.bankBranchName':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.companyProperty.businessLicenseNo':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.companyProperty.businessLicenseValidity':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.photoCopyMap.certificatesFront':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.photoCopyMap.certificatesBack':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        // 'kjtMerchant.photoCopyMap.bankCardFont':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
        //                 if (this.kjtSwitch&&value=='') {
        //                   callback(new Error('不能为空,请输入'));
        //                   callback();
        //                 }
        //               } },],
        // 'kjtMerchant.photoCopyMap.bankCardInHand':[{ required: true, trigger: "blur" ,validator:(rule, value, callback) => {
        //                 if (this.kjtSwitch&&value=='') {
        //                   callback(new Error('不能为空,请输入'));
        //                   callback();
        //                 }
        //               }},],
        // 'kjtMerchant.photoCopyMap.certificatesInHandFront':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
        //                 if (this.kjtSwitch&&value=='') {
        //                   callback(new Error('不能为空,请输入'));
        //                   callback();
        //                 }
        //               } },],
        'kjtMerchant.photoCopyMap.networkUrlPhoto':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.photoCopyMap.openLicense':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
        'kjtMerchant.photoCopyMap.license':[{ required: true, trigger: "blur",validator:(rule, value, callback) => {
                        if (this.kjtSwitch&&value=='') {
                          callback(new Error('不能为空,请输入'));
                          }else{
                          callback();
                        }
                      } },],
     },
    }
  },
  // 注册组件
  components: {},
   computed:{
    ...mapState(['getprovince'])
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
    this.slevelLists()
    this.getstoreClasslists()
    this.getleftmenus()
    this.getkjtEnableList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // ======================快捷通 获取 开始====================================
    // 
    getkjtSwitch(e){
      console.log(e,'=================re=================')
    },
     // 获取快捷通 开关集合
    getkjtEnableList(){
      kjtEnable({
        mids:''
      }).then(res=>{
        if(res.code==0){
          this.kjtEnableObj = res.data
        }
      })
    },
    //银行卡类型
    changekjtMerchantRadio(){
      if(this.sizeForm.kjtMerchant.radio == 1){
        this.sizeForm.kjtMerchant.companyOrPerson = 'B'
      }if(this.sizeForm.kjtMerchant.radio == 2){
        this.sizeForm.kjtMerchant.companyOrPerson = 'C'
      }
    },
    //子商户类型
    changeCheckRadio() {
      // console.log(this.sizeForm.kjtMerchant.customerType)
      this.shopType = this.sizeForm.kjtMerchant.customerType
    },

    // 公司地址选择
    areaHandleChange(value){
      var label = this.$refs["area"].getCheckedNodes()
      console.log(label,'==================================')
	  console.log(value);
	  console.log(value[0]);
	  this.locationId = value
	  this.sizeForm.province = this.sizeForm.kjtMerchant.province
	  this.sizeForm.city = value[1]
	  if(value[3]){
		  this.sizeForm.area = value[3]
	  }
      this.sizeForm.companyLocation = value[value.length-1]
      this.sizeForm.kjtMerchant.province = label[0].pathLabels[0]
      this.sizeForm.kjtMerchant.city = label[0].pathLabels[1]
      this.sizeForm.kjtMerchant.area = label[0].pathLabels[2]
      if(label[0].pathLabels[2] == undefined){
        this.sizeForm.kjtMerchant.area = label[0].pathLabels[1]
      }
      console.log(this.sizeForm.companyLocation)
      console.log(typeof(this.sizeForm.companyLocation))
      console.log(this.sizeForm.kjtMerchant.province,this.sizeForm.kjtMerchant.city ,this.sizeForm.kjtMerchant.area)
    },

    // 开户行地址选择
    bankAreaHandleChange(value){
      this.sizeForm.kjtMerchant.bankProv = value[value.length-1]
      this.sizeForm.kjtMerchant.bankCity = value[1]
      // console.log(this.kjtMerchant.bankProv, this.kjtMerchant.bankCity,value)
    },
 // ======================快捷通 获取 结束====================================
    //获取店铺id
    getShopid(id){
      this.bxscId = id
      localStorage.setItem('bxscId', this.bxscId)
    },
    // // 地址选择
    // areaHandleChange(value){
    //   this.sizeForm.companyLocation = value[value.length-1]
    // },
    // 经营类目获取选中的节点
    getCheckedNodes(node){
      let selectedType =[]
      let nodesObj = this.$refs['cascader'].getCheckedNodes()
      nodesObj.forEach((item)=>{
        selectedType.push(item.value);
      })
      this.sizeForm.mainproduct = selectedType.toString()

    },
    // // 获取省地址
    // getprovinceList(){
    //   area_list()
    //     .then(res => {
    //       if (res.code == 0) {
    //         this.getprovince = res.data;
    //       } else {
    //         this.$message({
    //           type: 'info',
    //           message: res.msg
    //         })
    //       }
    //     })
    //     .catch(err => {
    //       this.editFormVisible = false
    //       this.loading = false
    //       this.$message.error('获取地址失败，请稍后再试！')
    //     })
    // },

    // 店铺等级
    slevelLists(){
       slevelList()
            .then(res => {
              if (res.code == 0) {
                this.levelList = res.data;
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('提交失败，请稍后再试！')
            })
    },
    // 店铺分类
    getstoreClasslists(){
       storeClasslist()
            .then(res => {
              // console.log(res)
              if (res.length >0 ) {
                this.storeClasslists = res
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('提交失败，请稍后再试！')
            })
    },
   // 店铺类目
    getleftmenus(){
       leftmenu()
            .then(res => {
              if (res.code == 0) {
                this.leftmenus = res.data
                console.log(this.leftmenus,'ccc');
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('提交失败，请稍后再试！')
            })
    },

    submitApply(sizeForm) {
      let req = {}
      if(this.kjtSwitch){
          this.sizeForm.kjtMerchant.email = this.sizeForm.emergencyManEmail  
          this.sizeForm.kjtMerchant.phoneNum = this.sizeForm.phone   
          this.sizeForm.kjtMerchant.address = this.sizeForm.address
          this.sizeForm.kjtMerchant.contactName = this.sizeForm.contactPerson
          this.sizeForm.kjt = this.kjtSwitch?1:0
          this.sizeForm.kjtMerchant.companyProperty.companyName = this.sizeForm.companyName
          this.sizeForm.sellerAccount = this.userInfo.loginName
          req= this.sizeForm
					console.log('-----');
      }else{
				console.log('-----2');
        this.sizeForm.kjt = this.kjtSwitch?1:0
        let {kjtMerchant,...params}=this.sizeForm
        req=params
      }
      this.$refs.sizeForm.validate((valid) => {
        if (valid) {
         merchantForm(JSON.parse(JSON.stringify(req)))
            .then(res => {
              if (res.data.code == 0) {
                 this.$router.push('/merchantStatus')
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('提交失败，请稍后再试！')
            })
          } else{
            this.kjtSwitch=this.kjtSwitch==1?true:false
          }
      });
    },
    // handleAvatarSuccess(res, file) {
    //   console.log(file.raw,URL.createObjectURL(file.raw))
    //     this.urlImg = URL.createObjectURL(file.raw) // 用来图片预览的
    //     this.sizeForm.businessLicense =URL.createObjectURL(file.raw);
    //     this.sizeForm.businessLicense =res.url
    //     // this.sizeForm.businessLicense =URL.createObjectURL(file.raw). substring(URL.createObjectURL(file.raw).lastIndexOf("/"));
    // },

      handleAvatarSuccess(response, file, fileList,index) {
        console.log(response, file, fileList,index)
        if(index==1){
          if(this.kjtSwitch){
            this.urlImg = URL.createObjectURL(file.raw) // 用来图片预览的
            this.sizeForm.businessLicense  =response.data.url;
            this.sizeForm.kjtMerchant.companyProperty.businessLicense  =response.data.kjtUrl;
          }else{
            this.urlImg = response.url;
            // this.urlImg = URL.createObjectURL(file.raw) // 用来图片预览的
            this.sizeForm.businessLicense =URL.createObjectURL(file.raw);
            this.sizeForm.businessLicense =response.url
          }
          }if(index==2){
            this.urlImgTwo = URL.createObjectURL(file.raw)
            this.sizeForm.kjtMerchant.photoCopyMap.certificatesFront =response.data.kjtUrl;
            this.sizeForm.kjtMerchant.photoCopyMap.certificatesFrontBak =response.data.url;
        }if(index==3){
            this.urlImgThree = URL.createObjectURL(file.raw)
            this.sizeForm.kjtMerchant.photoCopyMap.certificatesBack =response.data.kjtUrl;
            this.sizeForm.kjtMerchant.photoCopyMap.certificatesBackBak =response.data.url;
        }if(index==4){
            this.urlImgFour = URL.createObjectURL(file.raw)
            this.sizeForm.kjtMerchant.photoCopyMap.bankCardFont =response.data.kjtUrl;
            this.sizeForm.kjtMerchant.photoCopyMap.bankCardFontBak =response.data.url;
        }if(index==5){
            this.urlImgFive = URL.createObjectURL(file.raw)
            this.sizeForm.kjtMerchant.photoCopyMap.bankCardInHand =response.data.kjtUrl;
            this.sizeForm.kjtMerchant.photoCopyMap.bankCardInHandBak =response.data.url;
        }if(index==6){
            this.urlImgSix = URL.createObjectURL(file.raw)
            this.sizeForm.kjtMerchant.photoCopyMap.certificatesInHandFront =response.data.kjtUrl;
            this.sizeForm.kjtMerchant.photoCopyMap.certificatesInHandFrontBak =response.data.url;
        }if(index==7){
            this.urlImgSeven = URL.createObjectURL(file.raw)
            this.sizeForm.kjtMerchant.photoCopyMap.networkUrlPhoto =response.data.kjtUrl;
            this.sizeForm.kjtMerchant.photoCopyMap.networkUrlPhotoBak =response.data.url;
        }if(index==8){
            this.urlImgEight = URL.createObjectURL(file.raw)
            this.sizeForm.kjtMerchant.photoCopyMap.openLicense =response.data.kjtUrl;
            this.sizeForm.kjtMerchant.photoCopyMap.openLicenseBak =response.data.url;
        }if(index==9){
            this.urlImgNine = URL.createObjectURL(file.raw)
            this.sizeForm.kjtMerchant.photoCopyMap.license =response.data.kjtUrl;
            this.sizeForm.kjtMerchant.photoCopyMap.licenseBak =response.data.url;
        }
        // this.sizeForm.businessLicense =URL.createObjectURL(file.raw). substring(URL.createObjectURL(file.raw).lastIndexOf("/"));
    },
    
      beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      }
  },  
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
.leftaside {
  width: 300px;
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
  margin-bottom: 40px;
  .el-submenu .el-menu-item {
    height: 25px;
    line-height: 25px;
  }
  /deep/.el-submenu__title,
  .el-menu-item {
    height: 40px;
    line-height: 40px;
  }
  /deep/.el-submenu__title:focus,
  /deep/.el-submenu__title:hover,
  /deep/.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow,
  /deep/.el-menu-item.is-active {
    color: #f42424;
  }
}
.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  font-weight: 700;
}

.rightaside {
  h3 {
    font-size: 14px;
    color: #333;
    background: #fcf8e3;
    padding: 14px;
    border: 1px solid #faebcc;
    border-radius: 4px;
  }
  p {
    font-size: 18px;
  }
  .nextPart {
    margin-top: 20px;
    /deep/.el-cascader.el-cascader--mini {
        width: 100%;
    }
  }
  .nextButtom {
    background: #ff6700;
    border: 1px solid #ff6700;
  }
    /deep/.avatar-uploader {
        padding: 20px;
        box-sizing: border-box;
    }
  /deep/.el-upload.el-upload--text {
        border: 1px solid #ccc;
    }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 160px;
    height: 160px;
    line-height: 160px;
    text-align: center;
  }
  .avatar {
    width: 160px;
    height: 160px;
    display: block;
  }
  /deep/input[disabled], input[disabled="disabled"], /deep/input[readonly], /deep/input[readonly="readonly"]{
    background: white !important;
  }
  /deep/.el-select.el-select--mini {
    width: 100%;
}
}
.kjt{
  /deep/input[type=checkbox]+span{
    height: 20px;
  }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/merchantSettled/merchantForm.vue